/**
 * Vuex Module: Runtime Configuration
 *
 * Stores multiTenantEnabled flag from backend.
 * Note: Named 'runtimeConfig' to avoid collision with product config module
 */

import { fetchRuntimeConfig } from '@/services/runtimeConfig';

const state = {
  loaded: false,
  multiTenantEnabled: false,
};

const getters = {
  isMultiTenantEnabled: (s) => s.multiTenantEnabled,
};

const mutations = {
  SET_CONFIG(s, config) {
    // eslint-disable-next-line no-param-reassign
    s.multiTenantEnabled = config.multiTenantEnabled || false;
    // eslint-disable-next-line no-param-reassign
    s.loaded = true;
  },
};

const actions = {
  async loadConfig({ commit, state: s }) {
    if (s.loaded) return;

    try {
      const config = await fetchRuntimeConfig();
      commit('SET_CONFIG', config);
    } catch (error) {
      console.error('Failed to load config:', error);
      commit('SET_CONFIG', { multiTenantEnabled: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
